import { useMemo, useState } from 'react';
import { type Validation } from './validation';

interface Params {
  value?: string;
  validate?: (value?: string) => Validation | undefined;
}

export const useFieldValidation = ({ value, validate }: Params) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const validation = useMemo<Validation | undefined>(
    () => (isTouched || isDirty ? validate?.(value) : undefined),
    [isTouched, isDirty, validate, value],
  );

  return {
    validation,
    displayError: validation?.valid === false,
    markTouched: () => setIsTouched(true),
    markDirty: () => setIsDirty(true),
  };
};
